export default {
  fields: {
    demo: {
      label: 'Opret demo',
    },
    ai: {
      label: 'AI-optimeret',
    },
    restaurant_type: {
      label: 'Vælg restauranttype',
      types: {
        Pizza: 'Pizza 🍕',
        PizzaDelivery: 'Pizzalevering 🍕🚗',
        PizzaNeapolitan: 'Napolitansk pizza 🍕',
        Italian: 'Italiensk 🇮🇹',
        Burger: 'Burger 🍔',
        Turkish: 'Tyrkisk 🇹🇷',
        Mexican: 'Mexicansk 🌮',
        Sushi: 'Sushi 🍱',
        Japanese: 'Japansk 🇯🇵',
        Vietnamese: 'Vietnamesisk 🇻🇳',
        Thai: 'Thai 🇹🇭',
        Asian: 'Asiatisk 🍜',
        Indian: 'Indisk 🥘',
        Bowls: 'Bowls 🥣',
        Vegan: 'Vegansk 🥑',
        Greek: 'Græsk 🏛️',
        Cafe: 'Café ☕️',
        Brunch: 'Brunch 🍵',
        Oriental: 'Orientalsk / Mellemøstlig 🧆',
        Spanish: 'Spansk / Tapas 🇪🇸',
        Persian: 'Persisk 🫖',
      },
    },
    plugins: {
      reservations: 'Reservationer',
      reservations_plan_hint:
        'Reservationer kræver en Partner-plan. Du bliver bedt om at aktivere den for {{name}}, når du opretter hjemmesiden.',
      catering: 'Catering',
      events: 'Events',
    },
    quarter: {
      label: 'Bydel',
      address_placeholder: 'Indtast adresse',
      quarter_placeholder: 'Indtast bydel',
    },
    delivery_areas: {
      label: 'Hvilke områder betjener I i byen?',
      city_placeholder: 'Indtast by',
      district_placeholder: 'Bydel 1, Bydel 2, Bydel 3',
    },
    best_dishes: {
      label: 'Hvad er jeres 3 bedste retter?',
      placeholder: 'Indtast retter (Kyllingeburger, Cheeseburger osv.)',
    },
    dietary_attributes: {
      label: 'Har I muligheder til folk, der vil spise:',
      placeholder: 'Vælg kostegenskaber',
      types: {
        vegetarian: 'Vegetarisk',
        vegan: 'Vegansk',
        halal: 'Halal',
        gluten_free: 'Glutenfri',
        dairy_free: 'Mælkefri',
        spicy: 'Krydret',
      },
    },
    family_owned: {
      label: 'Familieejet?',
      yes: 'Ja',
      no: 'Nej',
    },
    business_founding_year: {
      label: 'Hvornår blev restauranten startet (hvilket år)?',
    },
    business_owners: {
      label: 'Virksomhedsejere',
      placeholder: 'Indtast virksomhedsejer',
    },
    notes: {
      label: 'Tilføj yderligere bemærkninger (valgfrit)',
      placeholder: 'Eksempel: lokalt forankret restaurant, initiativer, ejet af et par...',
    },
    about_us: {
      title: 'Om os (forhåndsvisning)',
    },
  },
  sections: {
    plugins: 'Plugins',
    company_info: 'Generer virksomhedsinfo',
  },
  buttons: {
    find_district: 'Find bydel',
    generate: 'Generer',
    products: 'Produkter',
    add: 'Tilføj',
  },
};
